import { Link } from "react-router-dom";

export const CommunityBanner = () => (
  <section className="max-w-7xl mx-auto px-6 mt-24" data-testid="community-banner">
    <div className="grid lg:grid-cols-2 rounded-[2rem] overflow-hidden bg-[#1A1714] text-white">
      <div className="p-10 sm:p-14 flex flex-col justify-center">
        <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#D99B26]">Shop together</span>
        <h2 className="font-display text-3xl sm:text-4xl font-extrabold mt-4 leading-tight">Shopping is better with your people</h2>
        <p className="text-stone-300 mt-4 max-w-md text-sm sm:text-base">Share finds with friends, split delivery with family, and pay your way with mobile money or card.</p>
        <Link to="/shop" data-testid="community-shop-btn" className="mt-10 self-start bg-[#C85A32] hover:bg-[#A9481F] px-7 h-12 leading-[3rem] rounded-full font-semibold transition-colors">Start shopping</Link>
      </div>
      <img src="/img/customer-tablet.jpg" alt="Friends shopping on Afri-go" className="w-full h-80 lg:h-full object-cover object-top" />
    </div>
  </section>
);

export const AppPromo = () => (
  <section className="max-w-7xl mx-auto px-6 mt-24" data-testid="app-promo">
    <div className="grid md:grid-cols-2 gap-10 items-center">
      <img src="/img/customer-phone.jpg" alt="Afri-go shopper with phone" className="w-full max-w-md mx-auto h-auto rounded-[2rem] shadow-[0_30px_60px_-30px_rgba(200,90,50,0.6)]" />
      <div>
        <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#C85A32]">Afri-go in your hand</span>
        <h2 className="font-display text-3xl sm:text-4xl font-extrabold mt-4 leading-tight">Find it. Tap it. Pay with your phone.</h2>
        <p className="text-stone-600 mt-4 max-w-md">Browse thousands of styles and home essentials, then pay with M-Pesa, EcoCash, MoMo, PayPal or card. We deliver from city to village.</p>
        <Link to="/shop?category=clothing" data-testid="app-promo-btn" className="inline-block mt-8 bg-[#1A1714] hover:bg-[#C85A32] text-white px-7 h-12 leading-[3rem] rounded-full font-semibold transition-colors">Shop the look</Link>
      </div>
    </div>
  </section>
);

export const BusinessBanner = () => (
  <section className="max-w-7xl mx-auto px-6 mt-16" data-testid="business-banner">
    <div className="grid md:grid-cols-[2fr_3fr] rounded-[2rem] overflow-hidden bg-[#1E5E3A] text-white">
      <img src="https://images.unsplash.com/photo-1687422808289-e721259c9eb4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="African tailor at work" className="w-full h-80 md:h-full object-cover" />
      <div className="p-10 sm:p-14 flex flex-col justify-center">
        <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#D99B26]">For business</span>
        <h2 className="font-display text-3xl sm:text-4xl font-extrabold mt-4 leading-tight">Stock your shop for less</h2>
        <p className="text-emerald-100 mt-4 max-w-lg text-sm sm:text-base">Tailors, boutiques and salons across Africa restock fabrics, tools and beauty products on Afri-go and pay with mobile money.</p>
        <Link to="/shop" data-testid="business-shop-btn" className="mt-8 self-start bg-[#D99B26] hover:bg-[#c08820] text-[#1A1714] px-7 h-12 leading-[3rem] rounded-full font-semibold transition-colors">Browse wholesale-friendly deals</Link>
      </div>
    </div>
  </section>
);
